import CloseIcon from "@mui/icons-material/Close";
import Logger from "../../services/Logger";
import { Box } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { BootstrapDialog } from "../../admin/components/BootstrapDialogTitle";
import ConfirmDialog from "../../admin/components/ConfirmDialog";
import CustomButton from "../../admin/components/CustomButton";
import ContactService from "./ContactService";

export default function ContactCardDialog({ open, setOpen, selectionId, callback }) {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [created, setCreated] = useState("");
    const [subject, setSubject] = useState("");
    const [content, setContent] = useState("");
    const [comment, setComment] = useState("");

    const [openDelete, setOpenDelete] = useState(false);

    useEffect(() => {
        // Logger.log("selectionId==" + selectionId);
        if (selectionId) {
            ContactService.requestDetail(selectionId, setFirstName, setLastName, setEmail, setCreated, setSubject, setContent);
        }
    }, [selectionId]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSaveComment = () => {};

    const handleDelete = (id) => {
        ContactService.deleteContact(id).then(() => {
            setOpen(false);
            callback();
        });
    };

    return (
        <div>
            <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Contact details
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField
                            label="First Name"
                            variant="standard" // Change variant to standard
                            fullWidth
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            margin="normal"
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        <TextField
                            label="Last Name"
                            variant="standard" // Change variant to standard
                            fullWidth
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            margin="normal"
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Box>
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField
                            label="Email"
                            variant="standard" // Change variant to standard
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            margin="normal"
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                        <TextField
                            label="Created"
                            variant="standard" // Change variant to standard
                            fullWidth
                            value={created}
                            onChange={(e) => setCreated(e.target.value)}
                            margin="normal"
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Box>
                    <TextField
                        label="Subject"
                        variant="standard" // Change variant to standard
                        fullWidth
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        margin="normal"
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                    <TextField
                        label="Context"
                        variant="standard" // Change variant to standard
                        fullWidth
                        multiline
                        rows={4}
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        margin="normal"
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                    <TextField
                        label="Admin's Comment"
                        variant="standard" // Change variant to standard
                        fullWidth
                        multiline
                        rows={4}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        margin="normal"
                        helperText="Comment for the user's context"
                    />
                </DialogContent>
                <DialogActions sx={{ justifyContent: "space-between", p: 2 }}>
                    <CustomButton variant={"contained"} onClick={() => setOpenDelete(true)} color="warning">
                        Delete
                    </CustomButton>
                    <CustomButton variant={"contained"} onClick={handleSaveComment}>
                        Save
                    </CustomButton>
                </DialogActions>
            </BootstrapDialog>

            <ConfirmDialog
                open={openDelete}
                setOpen={setOpenDelete}
                title="Delete Contact"
                message="Are you sure you want to permanently delete this contact? This action cannot be undone."
                targetId={selectionId}
                callback={handleDelete}
            />
        </div>
    );
}
